import React from 'react';
import { v4 as uuid } from 'uuid';
import { format } from 'date-fns';
import { CheckmarkGreen, Tag } from 'esa-ui-library';
import { PropertyType, toAmountString } from '../../../common';
import styles from '../Games/Games.module.scss';

const getDeviceLabel = (value: number | string): string => {
	switch (Number(value)) {
		case 0:
			return 'Desktop only';
		case 1:
			return 'Mobile only';
		case 9:
			return 'All devices';
		default:
			return 'Unknown';
	}
};

export const getRows = (campaigns: PropertyType[], partners: PropertyType[]): PropertyType[] => {
	const getPartnerLabel = (skinId: number | string): string => {
		const allOptions = partners.flatMap((group: any) => group.options || []);
		const match = allOptions.find((opt: any) => Number(opt.skinId) === Number(skinId));
		return match ? match.label : `#${skinId}`;
	};

	return campaigns.map((c: PropertyType) => [
		<span key={uuid()}>{c.campaign_id}</span>,
		<span key={uuid()}>{c.name}</span>,
		<span key={uuid()}>{c.description}</span>,
		<span key={uuid()}>{getPartnerLabel(c.partner_id)}</span>,
		<span key={uuid()}>
			<Tag text={c.status} yellow={c.status === 'Upcoming'} lightGreen={c.status === 'Running'} />
		</span>,
		<span key={uuid()}>
			{format(new Date(c.start_date), 'MMM dd, yyyy HH:mm')} – {format(new Date(c.end_date), 'MMM dd, yyyy HH:mm')}
		</span>,
		<span key={uuid()}>{toAmountString(c.freespin_total_value / 100, c.freespin_currency ?? 'EUR')}</span>,
		<span key={uuid()}>{toAmountString(c.freespin_bet_value / 100, c.freespin_currency ?? 'EUR')}</span>,
		<span key={uuid()}>{c.freespin_currency}</span>,
		<span key={uuid()}>{c.freespin_expiry}</span>,
		<span className={styles.DataIcon} key={uuid()}>
			{c.all_games === true ? <CheckmarkGreen /> : ''}
		</span>,
		<span className={styles.DataIcon} key={uuid()}>
			{c.all_users === true ? <CheckmarkGreen /> : ''}
		</span>,
		<span className={styles.DataIcon} key={uuid()}>
			{c.auto_award_on_launch === true ? <CheckmarkGreen /> : ''}
		</span>,
		<span key={uuid()}>{getDeviceLabel(c.device)}</span>,
		<span className={styles.DataIcon} key={uuid()}>
			{c.allow_api_award === true ? <CheckmarkGreen /> : ''}
		</span>,
	]);
};
